module.exports = __webpack_public_path__ + "static/img/custom-api.3075d260.png";